import type { FC } from 'react';

import { Validation } from './components';
import type { ValidationProps } from './components/types';

interface ValidationsProps {
  isDark?: boolean;
  validations?: ValidationProps[];
}

const Validations: FC<ValidationsProps> = ({ isDark, validations }) => {
  // biome-ignore lint/style/useBlockStatements: single-line early return
  if (!validations) return <></>;

  return (
    <div className="flex flex-col" css={{ gap: '12px' }}>
      {validations.map((validation, i) => {
        return (
          // biome-ignore lint/suspicious/noArrayIndexKey: index as key is acceptable here
          <Validation key={`validation-${i}`} {...validation} isDark={isDark} />
        );
      })}
    </div>
  );
};

export default Validations;
